import React from "react";
import "./AboutCivilink.css";
import logo from "../../assets/logo.png";

export default function AboutCivilink() {
  return (
    <div className="about-page">

      {/* Header */}
      <div className="about-header">

        <div className="about-logo">
          <img src={logo} alt="Civilink Logo" />
        </div>

        <h1>Civilink Private Limited</h1>

        <p className="tagline">
          Building India's Digital Construction Ecosystem
        </p>

      </div>

      {/* About */}
      <div className="about-card">

        <h2>🏢 About Civilink</h2>

        <p>
          Civilink Private Limited is a construction technology company
          connecting homeowners, engineers, architects, contractors,
          suppliers and vendors through one trusted digital platform.
        </p>

        <p>
          Our mission is to simplify construction by making quality
          materials, trusted professionals and digital services easily
          accessible for everyone.
        </p>

      </div>

      {/* Mission */}

      <div className="about-card">

        <h2>🎯 Mission</h2>

        <p>
          To simplify construction through technology by connecting
          homeowners, professionals and suppliers on a single trusted
          platform.
        </p>

      </div>

      {/* Vision */}

      <div className="about-card">

        <h2>👁 Vision</h2>

        <p>
          To become India's most trusted digital construction ecosystem.
        </p>

      </div>

      {/* Services */}

      <div className="about-card">

        <h2>🛠 Our Services</h2>

        <ul>

          <li>Construction Material Marketplace</li>

          <li>Verified Engineers</li>

          <li>Architects</li>

          <li>Contractors</li>

          <li>Interior Designers</li>

          <li>Equipment Rental</li>

          <li>Construction Services</li>

          <li>Digital Construction Solutions</li>

        </ul>

      </div>

      {/* Why */}

      <div className="about-card">

        <h2>⭐ Why Choose Civilink?</h2>

        <ul>

          <li>Trusted Construction Platform</li>

          <li>Verified Professionals</li>

          <li>Transparent Marketplace</li>

          <li>Easy Material Procurement</li>

          <li>Future Ready Technology</li>

          <li>Customer First Approach</li>

        </ul>

      </div>

      {/* Company */}

      <div className="about-card">

        <h2>🏢 Company Information</h2>

        <table className="info-table">

          <tbody>

            <tr>
              <td>Company</td>
              <td>Civilink Private Limited</td>
            </tr>

            <tr>
              <td>CIN</td>
              <td>U47912TN2026PTC189283</td>
            </tr>

            <tr>
              <td>Founder & CEO</td>
              <td>Madhaw Ashokkumar</td>
            </tr>

            <tr>
              <td>Registered Office</td>
              <td>
                No.925,
                <br />
                Kambanur,
                <br />
                Tirupathur Taluk,
                <br />
                 (Karaikudi),
                <br />
                Tamil Nadu, India.
              </td>
            </tr>

          </tbody>

        </table>

      </div>

      {/* Contact */}

      <div className="about-card">

        <h2>📞 Contact Us</h2>

        <div className="contact-list">

          <a href="https://www.civilink.in" target="_blank" rel="noreferrer">
            🌐 www.civilink.in
          </a>

          <a href="mailto:civilink.official@gmail.com">
            📧 civilink.official@gmail.com
          </a>

          <a href="https://wa.me/919344425095" target="_blank" rel="noreferrer">
            💬 +91 93444 25095
          </a>

          <a
            href="https://instagram.com/civilink.official"
            target="_blank"
            rel="noreferrer"
          >
            📸 @civilink.official
          </a>

          <a
            href="https://www.linkedin.com/in/civilink-private-limited-0905313a7/"
            target="_blank"
            rel="noreferrer"
          >
            💼 Civilink Private Limited
          </a>

        </div>

      </div>

      {/* Footer */}

      <div className="about-footer">

        <p>Version 1.0.0</p>

        <p>© 2026 Civilink Private Limited</p>

        <p>All Rights Reserved.</p>

      </div>

    </div>
  );
}